__turbopack_context__.v({
  "control": "_99hYHq_control",
  "controls": "_99hYHq_controls",
  "docked": "_99hYHq_docked",
  "expanded": "_99hYHq_expanded",
  "help": "_99hYHq_help",
  "mini": "_99hYHq_mini",
  "panel": "_99hYHq_panel",
  "video": "_99hYHq_video",
});
